import { apiService } from "./apiService";

export interface GlobalSearchResultItem {
  id: string;
  title: string;
  subtitle: string;
  category: "patients" | "prescriptions" | "invoices" | "admissions" | "items" | "doctors" | "appointments";
  categoryLabel: string;
  badge?: string;
  badgeVariant?: "default" | "outline" | "success" | "warning" | "danger";
  route: string;
  metadata?: Record<string, any>;
}

export interface GlobalSearchCategory {
  key: string;
  label: string;
  icon: string;
  count: number;
  items: GlobalSearchResultItem[];
}

export interface GlobalSearchResponse {
  query: string;
  totalMatches: number;
  categories: GlobalSearchCategory[];
}

class GlobalSearchService {
  async search(query: string, scope: string = "all", limit: number = 6, signal?: AbortSignal): Promise<GlobalSearchResponse> {
    if (!query || query.trim().length < 2) {
      return { query: "", totalMatches: 0, categories: [] };
    }

    try {
      const response = await apiService.request<GlobalSearchResponse>({
        method: "GET", url: "/global-search", params: { q: query.trim(), scope, limit },
        signal, showNotifications: false,
      });

      return (response as any)?.data || response || { query, totalMatches: 0, categories: [] };
    } catch (err: any) {
      if (signal?.aborted) throw err;
      console.warn("Global search failed:", err);
      return { query, totalMatches: 0, categories: [] };
    }
  }
}

export const globalSearchService = new GlobalSearchService();
export default globalSearchService;
